export default "__VITE_ASSET__Cl$EmJsH__"